<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         big-search
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <b-row>

            <b-col cols="4">

              <t-input-code-label enterprise
                                  v-model="form.enterpriseId"/>

            </b-col>

            <b-col cols="4">

              <t-input-code-label environment
                                  v-model="form.environmentId"/>

            </b-col>

            <b-col cols="4">

              <t-input-search v-model="form.regulationId"
                              :options="regulationOptions"
                              label="Norma Técnica" select/>

            </b-col>

          </b-row>

          <b-row>

            <t-input-search cols="4" v-model="form.sectorId" :options="sectorOptions"
                            label="Categoria"
                            select/>

            <b-col cols="4">

              <t-input-person executor
                              v-model="form.executorId"/>

            </b-col>

            <b-col cols="4">

              <t-input-code-label inspector
                                  v-model="form.inspectorId"/>

            </b-col>

          </b-row>

          <b-row>

            <b-col cols="4">

              <t-input-code-label type-checklist-item
                                  v-model="form.typeChecklistItemId"/>
            </b-col>

            <b-col cols="4">

              <t-input-code-label type-pathology
                                  v-model="form.typePathologyId"/>
            </b-col>


            <b-col cols="4">

              <t-input-search v-model="form.typeCriticalityId" :options="typeCriticalityOptions"
                              label="Criticidade"
                              select
                              placeholder="Todas"/>

            </b-col>


          </b-row>


          <b-row>


            <b-col cols="6">
              <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

            </b-col>

            <b-col cols="6">
              <t-input-search v-model="form.deadline" enable-range date label="Prazo"/>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="4">

              <t-input-search v-model="form.hasOccurrencePending" :options="yesOrNotOptions"
                              label="Apontamento pendente?" boolean/>

            </b-col>

            <b-col cols="4">

              <t-input-search v-model="form.occurrenceStatusId" :options="typeOccurrenceStatusOptions"
                              label="Status Apontamento" checkbox

              />
            </b-col>

            <b-col cols="4">


              <t-input-search v-model="form.otherCodeLabel"
                              label="Cód. Iterno" />


<!--              <t-input-search v-model="form.conclusion" number range
                              label="Conclusão mínima (%)"

              />-->
            </b-col>

          </b-row>


        </t-content-header-search-default>
      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               primary-key-column="occurrenceNumber" link-primary-column="occurrenceCodeLabel">


        <template #first-column="{item}">

          <t-list-link-primary
              :label="item.occurrenceCodeLabel" :userAuth="userAuth" :id="item.occurrenceNumber"
              :path="currentPage.path"/>

        </template>

        <template #item(typeCriticality)="{item}">

          <span :style="{'color': item.typeCriticalityColor}">
            {{ item.typeCriticality }}
          </span>

        </template>

        <template #item(conclusion)="{item}">

          <t-progress-bar-line :progress="item.conclusion"/>

        </template>




        <template #item(riskResult)="{item}">

          <b-badge v-if="item.riskResult >= 84"
                   variant="danger">{{ item.riskResult }}
          </b-badge>

          <b-badge v-else-if="item.riskResult >= 41"
                   variant="warning">{{ item.riskResult }}
          </b-badge>

          <b-badge v-else
                   variant="success">{{ item.riskResult }}
          </b-badge>



        </template>

        <template #item(typeOccurrenceStatus)="{item}">

          <span class="badge badge-success"
                :style="{'background-color': item.typeOccurrenceStatusColor,'color': item.typeOccurrenceStatusColorText}">{{
              item.typeOccurrenceStatus
            }}</span>


        </template>

        <template #item(finishedDate)="{item}">

          <span
              v-if="item.finishedDate !== undefined && item.finishedDate !== null">{{
              item.finishedDate | datetime
            }}</span>
          <small v-else>Não finalizada</small>

        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import SectorService from "@/services/modules/agent/Sector.service";
import TypeCriticalityService from "@/services/modules/checklist/TypeCriticality.service";
import TypeOccurrenceStatusService from "@/services/modules/checklist/TypeOccurrenceStatus.service";
import RegulationService from "@/services/modules/checklist/Regulation.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Occurrence',
  data() {
    return {
      enableGeneralFields: false,
      form: {
        enterpriseId: 0,
        environmentId: 0,
        executorId: 0,
        inspectorId: 0,
        spotFolderId: 0,
        sectorId: 0,
        regulationId: 0,
        typeChecklistItemId: 0,
        typePathologyId: 0,
        hasOccurrencePending: null,
        occurrenceStatusId: [],
        conclusionMin: 0,
        conclusionMax: 0,
        typeCriticalityId: 0,
        issueDate: "",
        deadline: "",
        otherCodeLabel: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      sectorOptions: [],
      typeOccurrenceStatusOptions: [],
      typeCriticalityOptions: [],
      regulationOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      delete this.form.status

      this.breadcrumb = [
        //{text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {

      await SectorService.selectList("").then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))


      await TypeCriticalityService.selectList("").then((list) => {
        this.typeCriticalityOptions = list
      }).catch(error => this.responseError(error))


      await RegulationService.selectList("").then((list) => {
        this.regulationOptions = list
      }).catch(error => this.responseError(error))


      await TypeOccurrenceStatusService.selectList("").then((list) => {
        this.typeOccurrenceStatusOptions = list
      }).catch(error => this.responseError(error))


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

